import { TextField } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { Col, Row, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import axios from "axios";
import { serverApi } from "../../../config/Keys";
import isEmpty from "../../../store/validation/is-Empty";
import moment from "moment";
import {
  ORDER_STATUS,
  PAYMENT_TYPE,
  PAYMENT_STATUS,
} from "../../../enums/OrderEnums";
import { useHistory } from "react-router-dom";

function DebitWithReference(props) {
  let history = useHistory();
  const [orderId, setOrderId] = useState("");
  const [orderData, setOrderData] = useState(null);
  const auth = useSelector((state) => {
    return !isEmpty(state.auth) ? state.auth.user : "";
  });

  const [selectItems, setSelectItems] = useState([]);
  const [selectedAll, setSelectedAll] = useState(false);
  const [notifyUser, setNotifyUser] = useState(false);
  const [comment, setComment] = useState("");
  const [refund, setRefund] = useState(0);
  const [adjustment, setAdjustment] = useState(0);
  const [userData, setUserData] = useState({});

  const addItems = (item) => () => {
    if (selectItems.find((ele) => item._id === ele._id)) {
      let items = selectItems.filter((ele) => item._id !== ele._id);
      setSelectItems(items);
    } else {
      let items = [...selectItems, item];
      setSelectItems(items);
    }
  };

  const addAllItems = () => {
    let data = orderData.order_items.filter(
      (e) => !e.isCancelled && !e.isSubstituted
    );
    if (JSON.stringify(selectItems) === JSON.stringify(data)) {
      setSelectItems([]);
      setSelectedAll(false);
    } else {
      setSelectItems(data);
      setSelectedAll(true);
    }
  };

  const getOrderData = async () => {
    let data = await axios.get(`${serverApi}/ordering`, {
      params: { order_id: orderId },
      headers: {
        Authorization: auth.accessToken,
        "Content-Type": "application/json",
      },
    });
    if (data.data) {
      setOrderData(data.data);
      let user = await axios.get(
        `${serverApi}/user-check/${data.data.user_id}`,
        {
          headers: {
            Authorization: auth.accessToken,
            "Content-Type": "application/json",
          },
        }
      );
      if (user.data) {
        setUserData(user.data);
      }
    }
  };

  const makePayment = () => {
    history.push({
      pathname: "/memopayment",
      state: {
        payment: {
          refund: refund,
          orderData: orderData,
          comment: comment,
          adjustment: adjustment,
          userData: userData,
          items: selectItems,
        },
      },
    });
  };

  const calcTax = (data) => {
    let charges = 0;
    for (let j = 0; j < data.sur_charges.length; j++) {
      if (data.sur_charges[j].flag === "PERCENTAGE") {
        charges =
          (data.size.price * data.quantity * data.sur_charges[j].value) / 100 +
          charges;
      } else {
        charges = data.quantity * parseInt(data.sur_charges[j].value) + charges;
      }
    }
    return charges.toFixed(2);
  };

  useEffect(() => {
    if (!isEmpty(selectItems)) {
      let refundData = refund;
      for (let i = 0; i < selectItems.length; i++) {
        refundData = selectItems[i].size.price * selectItems[i].quantity;
      }
      setRefund(refundData);
    }
  }, [selectItems]);

  useEffect(() => {
    if (orderId.length >= 5) {
      getOrderData();
    }
  }, [orderId]);

  return (
    <div>
      <Row className="mt-3">
        <Col xs={12} md={3}>
          <TextField
            variant="outlined"
            fullWidth
            label="Order ID"
            type="number"
            name="OrderID"
            onChange={(e) => setOrderId(e.target.value)}
            value={orderId}
          />
        </Col>
      </Row>
      {orderData && (
        <>
          <Row className="mt-3">
            <Col xs={2}>
              <div className="f12-500">{`${
                orderData?.user_details?.first_name || ""
              } ${orderData?.user_details?.last_name || ""}`}</div>
              <div className="f12-400 mt-1">User Name</div>
            </Col>
            <Col xs={2}>
              <div className="d-flex">
                <div
                  className="d-flex align-items-center"
                  align="center"
                  style={{ backgroundColor: "#4CAF50", borderRadius: "50%" }}
                >
                  <img
                    src={require("../../../assets/images/Icon/round-done-button.svg")}
                    width="50px"
                    alt="Done"
                    title="Done"
                  />
                </div>
                <div>
                  <div className="f12-500">
                    {ORDER_STATUS[orderData?.order_status]}
                  </div>
                  <div className="f12-400 mt-1">Latest Order Status</div>
                </div>
              </div>
            </Col>
            <Col xs={2}>
              <div className="f12-500">Call</div>
              {/* <div className="f12-400 mt-1">Latest Order Status</div> */}
            </Col>
          </Row>
          <Row className="mt-3 p-3" style={{ backgroundColor: "#FFFFFF" }}>
            <Col md={8} style={{ borderRight: "2px solid #FAFAFA" }}>
              <div className="f12-700">Order & Account Info</div>
              <Row>
                <Col md={4}>
                  <div className="mt-2">
                    <div className="f12-500">{moment().format("lll")}</div>
                    <div className="f12-400">Creation Date & Time</div>
                  </div>
                  <div className="mt-2">
                    <div className="f12-500">{"NA"}</div>
                    <div className="f12-400">Device ID</div>
                  </div>
                </Col>
                <Col md={4}>
                  <div className="mt-2">
                    <div className="f12-500">{userData?.email || "-"}</div>
                    <div className="f12-400">User Email</div>
                  </div>
                  <div className="mt-2">
                    <div className="f12-500">NA</div>
                    <div className="f12-400">Point of Entry</div>
                  </div>
                </Col>
                <Col md={4}>
                  <div className="mt-2">
                    <div className="f12-500">{`${
                      orderData?.user_details?.country_code || ""
                    } ${orderData?.user_details?.mobile_number || ""}`}</div>
                    <div className="f12-400">User Phone Number</div>
                  </div>
                  <div className="mt-2">
                    <div className="f12-500">NA</div>
                    <div className="f12-400">IP Address</div>
                  </div>
                </Col>
              </Row>
            </Col>
            <Col md={4}>
              <div className="f12-700">Payment Info</div>
              <Row>
                <Col md={6}>
                  <div className="mt-2">
                    <div className="f12-500">
                      {PAYMENT_TYPE[orderData?.payment_method]}
                    </div>
                    <div className="f12-400">Payment Method</div>
                  </div>
                  <div className="mt-2">
                    <div className="f12-500">
                      {orderData?.total_amount || 0}
                    </div>
                    <div className="f12-400">Payment Amount</div>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mt-2">
                    <div className="f12-500">
                      {orderData?.transactional_id || "NA"}
                    </div>
                    <div className="f12-400">Payment Trans ID</div>
                  </div>
                  <div className="mt-2">
                    <div className="f12-500">
                      {PAYMENT_STATUS[orderData?.payment_status]}
                    </div>
                    <div className="f12-400">Payment Status</div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col md={12}>
              <div className="f12-700">Order Item List</div>
              <div>
                <input
                  type="checkbox"
                  onChange={addAllItems}
                  checked={selectedAll}
                />{" "}
                Select All
              </div>
              <div className="user-table-reusable-superadmin table-responsive">
                <Table>
                  <thead>
                    <tr className="super_admin_all_users_table_head">
                      <th style={{ width: "10%" }} className="f12-700"></th>
                      <th style={{ width: "10%" }} className="f12-700">
                        Item Code
                      </th>
                      <th style={{ width: "10%" }} className="f12-700">
                        Item Description
                      </th>
                      <th style={{ width: "10%" }} className="f12-700">
                        Price
                      </th>
                      <th style={{ width: "10%" }} className="f12-700">
                        Qty
                      </th>
                      <th style={{ width: "10%" }} className="f12-700">
                        Item Status
                      </th>
                      <th style={{ width: "10%" }} className="f12-700">
                        Sub Total
                      </th>
                      <th style={{ width: "10%" }} className="f12-700">
                        Tax
                      </th>
                      <th style={{ width: "15%" }} className="f12-700">
                        Convenience Fee
                      </th>
                      <th style={{ width: "15%" }} className="f12-700">
                        Bag & Packing Fee
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {orderData?.order_items.map((data, index) => {
                      return (
                        <tr
                          key={index}
                          className="super_admin_all_users_table_body"
                          style={{ wordBreak: "break-word" }}
                        >
                          <td colSpan="7" className="p-0 w-100">
                            <table className="w-100 HideShowTable enMinWidth900">
                              <tbody>
                                <tr>
                                  <td style={{ width: "10%" }}>
                                    <div className="f14-500">
                                      <input
                                        type="checkbox"
                                        name=""
                                        checked={selectItems.find(
                                          (ele) => data._id === ele._id
                                        )}
                                        onChange={addItems(data)}
                                        disabled={data?.isCancelled}
                                      />
                                    </div>
                                  </td>
                                  <td style={{ width: "10%" }}>
                                    <div className="f12-500">
                                      {data?.item?.id}
                                    </div>
                                  </td>
                                  <td style={{ width: "10%" }}>
                                    <div className="f12-400">
                                      {data?.item?.name}
                                    </div>
                                  </td>
                                  <td style={{ width: "10%" }}>
                                    <div className="f12-400">{`₹ ${
                                      data?.size?.price
                                        ? (data?.size?.price)
                                            .toFixed(2)
                                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")
                                        : 0
                                    }`}</div>
                                  </td>
                                  <td style={{ width: "10%" }}>
                                    <div className="f12-400">
                                      {data?.quantity}
                                    </div>
                                  </td>
                                  <td style={{ width: "10%" }}>
                                    <div className="f12-400">
                                      {data?.isCancelled
                                        ? "Cancelled"
                                        : data?.isSubstituted
                                        ? "Substituted"
                                        : "Accepted"}
                                    </div>
                                  </td>
                                  <td style={{ width: "10%" }}>
                                    <div className="f12-400">{`₹ ${
                                      data?.size?.price
                                        ? (data?.size?.price * data?.quantity)
                                            .toFixed(2)
                                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")
                                        : 0
                                    }`}</div>
                                  </td>
                                  <td style={{ width: "10%" }}>
                                    <div className="f12-400">{`₹ ${calcTax(
                                      data
                                    )}`}</div>
                                  </td>
                                  <td style={{ width: "15%" }}>
                                    <div className="f12-400">{"-"}</div>
                                  </td>
                                  <td style={{ width: "15%" }}>
                                    <div className="f12-400">{"-"}</div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </Col>
          </Row>
          {!isEmpty(selectItems) && (
            <>
              <Row className="mt-4">
                <Col md={6}>
                  <TextField
                    variant="outlined"
                    multiline
                    rows="4"
                    label="Comment here"
                    fullWidth
                    onChange={(e) => setComment(e.target.value)}
                    value={comment}
                  />
                  <br />
                  <input
                    type="checkbox"
                    onChange={() => setNotifyUser(!notifyUser)}
                    checked={notifyUser}
                  />{" "}
                  Notify Customer By Email
                </Col>
                <Col md={6}>
                  <div className="f14-500">Memo Total</div>
                  <Row>
                    <Col md={6}>Sub Total</Col>
                    <Col md={6}>{orderData?.base_amount}</Col>
                    <Col md={6}>Discount</Col>
                    <Col md={6}>{"-"}</Col>
                    <Col md={6}>Tips</Col>
                    <Col md={6}>{orderData?.tip?.amount || 0}</Col>
                    <Col md={6}>Donation</Col>
                    <Col md={6}>{orderData?.donation?.amount || 0}</Col>
                    <Col md={6}>Grand Total</Col>
                    <Col md={6}>{orderData?.total_amount}</Col>
                    <Col md={6}>Refund Totals</Col>
                    <Col md={6}>
                      {" "}
                      <TextField
                        variant="outlined"
                        fullWidth
                        label=""
                        type="number"
                        name="refund"
                        onChange={(e) => setRefund(e.target.value)}
                        value={refund}
                      />
                    </Col>
                    <Col md={6}>Adjustment Fee</Col>
                    <Col md={6}>
                      {" "}
                      <TextField
                        variant="outlined"
                        fullWidth
                        label=""
                        type="number"
                        name="adjustment"
                        onChange={(e) => setAdjustment(e.target.value)}
                        value={adjustment}
                      />
                    </Col>
                    <Col md={6}>Net Refund</Col>
                    <Col md={6}>{refund - adjustment}</Col>
                  </Row>
                </Col>
              </Row>
              <div class="py-4 d-flex align-items-center mt-3 justify-content-center">
                <button
                  type="button"
                  class="btn-md mr-4 px-5 btn btn-outline-secondary"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  class="btn-md px-5 btn btn-danger"
                  onClick={makePayment}
                >
                  Submit
                </button>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
}

export default DebitWithReference;
